import { render, staticRenderFns } from "./ProductVersionsTable.vue?vue&type=template&id=e2a27d8e&scoped=true"
import script from "./ProductVersionsTable.vue?vue&type=script&lang=ts"
export * from "./ProductVersionsTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductVersionsTable.vue?vue&type=style&index=0&id=e2a27d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a27d8e",
  null
  
)

export default component.exports